import { DataFetchingClient } from 'data-fetching-client';
export const client = new DataFetchingClient({
  queryFieldPolicies: {
    tags: {
      keyArgs: ['knowledgeBaseId'],
      merge(existing = {
        paging: {},
        results: []
      }, incoming) {
        const tags = [...existing.results, ...incoming.results].reduce((acc, tag) => {
          acc[tag.id] = tag;
          return acc;
        }, {});
        return {
          results: Object.values(tags),
          paging: incoming.paging
        };
      }
    }
  }
});